module.exports = __webpack_public_path__ + "static/media/icon2.b4c3c341.svg";